import { LensPackage } from '../meta/IBrain';
import { getCookieByName } from '../utils/functions';

export function useEnableRemoveLenses() {
  const enableRemoveLensesCookie = getCookieByName('rxc_remove_lenses');

  if (!enableRemoveLensesCookie) return null;

  // function parseCondition(
  //   condition: string
  // ): (item: LensPackage['lensPackage']) => boolean {
  //   const jsExpression = condition
  //     .replace(/\bAND\b/g, '&&')
  //     .replace(/\bOR\b/g, '||')
  //     .replace(
  //       /([a-zA-Z0-9_]+)\s*(==|!=|!==|===|>=|<=|>|<)\s*(.+?)(?=\s*(?:AND|OR|\)|$))/g,
  //       (_, key, operator, rawValue) => {
  //         const trimmed = rawValue.trim();

  //         let value: string;
  //         if (trimmed === `''`) {
  //           value = '""';
  //         } else if (trimmed === 'null') {
  //           value = 'null';
  //         } else if (trimmed === 'undefined') {
  //           value = 'undefined';
  //         } else if (/^".*"$/.test(trimmed) || /^'.*'$/.test(trimmed)) {
  //           value = trimmed; // già stringa con virgolette
  //         } else if (!isNaN(Number(trimmed))) {
  //           value = trimmed; // numero
  //         } else {
  //           value = `"${trimmed}"`; // stringa implicita
  //         }

  //         return `item["${key}"] ${operator} ${value}`;
  //       }
  //     );

  //   return new Function('item', `return ${jsExpression};`) as (
  //     item: LensPackage['lensPackage']
  //   ) => boolean;
  // }
  function parseCondition(
    condition: string
  ): (item: LensPackage['lensPackage']) => boolean {
    const jsExpression = condition
      // AND/OR in JS
      .replace(/\bAND\b/g, '&&')
      .replace(/\bOR\b/g, '||')
      .replace(
        /([a-zA-Z0-9_]+)\s*(===|!==|==|!=|>=|<=|>|<)\s*('[^']*'|"[^"]*"|[^\s&|]+)/g,
        (_, key, operator, rawValue) => {
          const trimmed = rawValue.trim();

          let value: string;

          if (trimmed === `''` || trimmed === `""`) {
            value = '""';
          } else if (trimmed === 'null') {
            value = 'null';
          } else if (trimmed === 'undefined') {
            value = 'undefined';
          } else if (/^['"].*['"]$/.test(trimmed)) {
            value = trimmed; // già tra virgolette
          } else if (!isNaN(Number(trimmed))) {
            value = trimmed; // numero
          } else {
            value = `"${trimmed}"`; // fallback: stringa
          }

          return `item["${key}"] ${operator} ${value}`;
        }
      );

    try {
      return new Function('item', `return ${jsExpression};`) as (
        item: LensPackage['lensPackage']
      ) => boolean;
    } catch (err) {
      console.error('Errore nel parsing del filtro:', err);
      return () => false;
    }
  }

  const filterFn = parseCondition(enableRemoveLensesCookie as string);
  return filterFn;
}
